import { render, staticRenderFns } from "./OptionsCreate.vue?vue&type=template&id=52449d15&"
import script from "./OptionsCreate.vue?vue&type=script&lang=js&"
export * from "./OptionsCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52449d15')) {
      api.createRecord('52449d15', component.options)
    } else {
      api.reload('52449d15', component.options)
    }
    module.hot.accept("./OptionsCreate.vue?vue&type=template&id=52449d15&", function () {
      api.rerender('52449d15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/CustomField/types/OptionsCreate.vue"
export default component.exports